import React from "react";

const PageNotFound = ()=>{
    return <div className="border mx-16 my-16 h-96 rounded-lg text-white">
        <h1  className=" text-8xl font-bold text-center mt-16 "> PAGE NOT FOUND! <span className="text-[#dfce09]">400</span> </h1>
        
    </div>
}
export default PageNotFound